import { type SelectionCriterionDto, SelectionCriterionType } from "../../autogen/bff-api";

export interface ParsedCriterionKey {
  type: SelectionCriterionType | null;
  name: string;
}

const KNOWN_TYPES = new Set<string>(Object.values(SelectionCriterionType));

/** Composes the `"TYPE:Name"` key used to identify a qualification response. */
export const composeCriterionKey = (criterion: Pick<SelectionCriterionDto, "type" | "name">): string =>
  `${criterion.type}:${criterion.name}`;

/** Splits on the first colon so names that contain colons survive. */
export const parseCriterionKey = (key: string): ParsedCriterionKey => {
  const colon = key.indexOf(":");
  if (colon === -1) {
    return { type: null, name: key };
  }
  const rawType = key.slice(0, colon);
  const name = key.slice(colon + 1);
  return {
    type: KNOWN_TYPES.has(rawType) ? (rawType as SelectionCriterionType) : null,
    name,
  };
};
